/* eslint-disable max-len */
/* global  localStorage */
let _$timeout;
let _$q;
let _$location;
let _authorizationService;

export default class authorizationInterceptor {
  constructor(
    $timeout,
    $q,
    $location,
    authorizationService
  ) {
    _$timeout = $timeout;
    _$q = $q;
    _$location = $location;
    _authorizationService = authorizationService;
    console.log('app.interceptors.authorizationInterceptor created');
  }

  request(request) {
    const token = _authorizationService.getToken();

    if (token) {
      if (request.url === 'components/membership/login.html') {
        _$location.path('home');
        return request;
      }
      request.headers.Authorization = `Bearer ${token.access_token}`;
      request.headers.Origin_Application = 1; // theSafe
      return request;
    }
    const path = _$location.path();
    if (path !== '/login' && path !== '/password' && path.indexOf('/id_token') === -1) {
      _$timeout(() => {
        localStorage.setItem('lastAccessLocation', path);
        _$location.path('/login');
        return {};
      }, 0);
    }

    return request;
  }

  requestError(request) {
    console.error(`authorizationInterceptor: requestError status: ${request.status}`);
    return request;
  }

  response(response) {
    return response;
  }

  responseError(response) {
    if (response && response.status) {
      console.error(`authorizationInterceptor: responseError status: ${response.status}`);
      const status = response.status;

      if (status === 401) {
        const path = _$location.path();
        if (path && path !== '/login' && path !== '/password' && path.indexOf('/id_token') === -1) {
          localStorage.setItem('lastAccessLocation', path);
        }
        _authorizationService.revokeToken();
        _$location.path('/login');
        return;
      }
      return _$q.reject(response);
    }

    return _$q.reject(response);
  }
}

authorizationInterceptor.$inject = [
  '$timeout',
  '$q',
  '$location',
  'authorizationService'
];
